module.exports = __webpack_public_path__ + "img/pills_1.74614808.png";